import { Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { useAccount } from 'queries/accounts/useAccount';
import { useCreateAddress } from 'queries/accounts/useCreateAddress';

import AddressForm from 'components/@account/AddressForm';
import { AddressFormFields } from 'components/@account/types';
import Form from 'components/@forms/Form';

const defaultValues: AddressFormFields = {
  countryCode: '',
  address1: '',
  address2: '',
  postalCode: '',
  city: '',
};

interface Props {
  onClose: () => void;
}

const AddAddressForm = ({ onClose }: Props) => {
  const { createAddress, isLoading } = useCreateAddress();
  const { account } = useAccount();
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();

  const handleSubmit: SubmitHandler<AddressFormFields> = (data) => {
    createAddress(
      {
        countryCode: data.countryCode?.trim(),
        address1: data.address1?.trim(),
        address2: data.address2?.trim() || undefined,
        postalCode: data.postalCode?.trim(),
        city: data.city.trim(),
      },

      {
        onSuccess: () => {
          enqueueSnackbar(
            intl.formatMessage({
              id: 'account.address.add.success.alert',
            }),
            { variant: 'success' },
          );
          onClose();
        },
        onError: () => {
          enqueueSnackbar(
            intl.formatMessage({
              id: 'account.address.add.error.alert',
            }),
            { variant: 'error' },
          );
        },
      },
    );
  };

  return (
    <Form
      onSubmit={handleSubmit}
      defaultValues={{
        ...defaultValues,
        countryCode: account?.countryCode,
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      }}
    >
      <AddressForm />
      <Button
        variant="outlined"
        color="secondary"
        type="submit"
        loading={isLoading}
        sx={{ mt: 2, width: { xs: '100%', md: 'fit-content' } }}
      >
        <FormattedMessage id="account.address.add.button" />
      </Button>
    </Form>
  );
};

export default AddAddressForm;
